{
  "common": {
    "loading": "Załadunek...",
    "cancel": "Anulować",
    "save": "Ratować",
    "delete": "Usuwać",
    "edit": "Redagować",
    "close": "Zamknąć",
    "submit": "Składać",
    "saving": "Oszczędność...",
    "sending": "Przesyłka...",
    "error": "Błąd",
    "success": "Sukces",
    "warning": "Ostrzeżenie",
    "no_data": "Brak danych",
    "yes": "Tak",
    "no": "NIE",
    "back": "Z powrotem",
    "next": "Następny",
    "previous": "Poprzedni",
    "search": "Szukaj",
    "filter": "Filtr",
    "all": "Wszystko",
    "none": "Nic",
    "select": "Wybierać",
    "required": "Wymagany",
    "optional": "Fakultatywny",
    "actions": "Akcje",
    "status": "Status",
    "date": "Data",
    "time": "Czas",
    "name": "Nazwa",
    "email": "E-mail",
    "confirm": "Potwierdzać",
    "add": "Dodaj",
    "done": "Gotowe",
    "unknown": "Nieznany",
    "days": "dni",
    "to": "do",
    "save_changes": "Zapisz zmiany",
    "note": "Uwaga"
  },
  "time": {
    "day": "dzień",
    "days": "dni",
    "hour": "godzina",
    "hours": "godziny",
    "week": "tydzień",
    "weeks": "tygodnie",
    "month": "miesiąc",
    "months": "miesiące",
    "year": "rok",
    "years": "lat",
    "today": "Dzisiaj",
    "tomorrow": "Jutro",
    "yesterday": "Wczoraj"
  },
  "status": {
    "pending": "Aż do",
    "approved": "Zatwierdzony",
    "rejected": "Odrzucony",
    "cancelled": "Odwołany",
    "active": "Aktywny",
    "inactive": "Nieaktywny",
    "deleted": "Usunięto",
    "connected": "Połączony",
    "disconnected": "Bezładny",
    "available": "Dostępny",
    "coming_soon": "Już wkrótce"
  },
  "nav": {
    "dashboard": "Panel",
    "planner": "Planista",
    "team": "Zespół",
    "requests": "Wnioski",
    "calendar": "Kalendarz",
    "settings": "Ustawienia",
    "audit_trail": "Ślad audytu",
    "billing": "Rozliczanie",
    "help": "Pomoc",
    "help_center": "Centrum pomocy",
    "profile": "Profil",
    "my_balances": "Moje salda",
    "leave_history": "Historia urlopów",
    "restart_tour": "Uruchom ponownie wycieczkę",
    "logout": "Wyloguj się",
    "upgrade": "Uaktualnij do wersji Pro",
    "upgrade_subtitle": "Odblokuj wszystkie funkcje",
    "view_plans": "Zobacz plany"
  },
  "header": {
    "profile_settings": "Ustawienia profilu",
    "my_profile": "Mój profil",
    "workspace": "Przestrzeń robocza",
    "leave_balances": "Salda urlopowe",
    "no_balances": "Nie znaleziono sald urlopowych."
  },
  "balance": {
    "unlimited": "Nieograniczony",
    "days_left": "dni pozostało",
    "used": "używany",
    "remaining": "pozostały",
    "of": "z"
  },
  "trial": {
    "ends_today": "Twój okres próbny kończy się dzisiaj!",
    "ends_tomorrow": "Twój okres próbny kończy się jutro!",
    "ends_in_days": "Okres próbny kończy się za {dni} dni.",
    "upgrade_now": "Zaktualizuj teraz"
  },
  "feature_locked": {
    "title": "{feature} nie jest dostępna w Twoim planie",
    "description": "Zaktualizuj swój plan, aby odblokować tę funkcję i inne.",
    "button": "Zobacz plany"
  },
  "dashboard": {
    "title": "Panel",
    "out_today": "Dzisiaj dostępne",
    "out_on_date": "Wyszedł {data}",
    "no_absences": "Brak nieobecności",
    "upcoming": "Nadchodzące nieobecności",
    "upcoming_empty": "W tym tygodniu nie przewidujemy żadnych nieobecności",
    "my_balance": "Saldo mojego urlopu",
    "my_balances": "Moje saldo",
    "no_balance_data": "Brak danych o saldzie",
    "next_holiday": "Następne święto państwowe",
    "no_holidays": "Brak nadchodzących świąt",
    "next_vacation": "Moje następne wakacje",
    "nothing_booked": "Nic nie zarezerwowano!",
    "upcoming_birthdays": "Nadchodzące urodziny",
    "no_birthdays": "Brak nadchodzących urodzin",
    "birthday_today": "Dzisiaj!",
    "birthday_in_days": "za {days} {unit}",
    "everyone_in_office": "Wszyscy są w tym dniu w biurze",
    "request_leave": "Wniosek o urlop",
    "view_calendar": "Wyświetl kalendarz",
    "view_planner": "Zobacz Planer",
    "contact_support": "Skontaktuj się z pomocą techniczną"
  },
  "support": {
    "title": "Skontaktuj się z pomocą techniczną",
    "success_title": "Wiadomość wysłana!",
    "success_message": "Skontaktujemy się z Tobą najszybciej jak to możliwe.",
    "intro": "Potrzebujesz pomocy? Wyślij nam wiadomość, a wkrótce się z Tobą skontaktujemy.",
    "subject_label": "Temat",
    "subject_placeholder": "Krótki opis problemu",
    "message_label": "Wiadomość",
    "message_placeholder": "Proszę szczegółowo opisać swój problem lub pytanie...",
    "send_button": "Wyślij wiadomość"
  },
  "requests": {
    "page_title": "Prośby o urlop",
    "page_subtitle": "Przeglądanie i zarządzanie wnioskami urlopowymi",
    "new_request": "Wniosek o urlop",
    "unpaid_confirm": "Tylko {paid} {unit} tego wniosku jest pokryte z Twojego płatnego salda. Pozostałe {unpaid} {unit} zostaną wykorzystane jako urlop bezpłatny. Wysłać mimo to?",
    "filter": {
      "pending": "Aż do",
      "approved": "Zatwierdzony",
      "rejected": "Odrzucony",
      "all": "Wszystko",
      "all_employees": "Wszyscy pracownicy"
    },
    "table": {
      "employee": "Pracownik",
      "type": "Typ",
      "dates": "Daty",
      "duration": "Czas trwania",
      "status": "Status",
      "reason": "Powód",
      "actions": "Akcje"
    },
    "action": {
      "approve": "Zatwierdzić",
      "reject": "Odrzucić",
      "cancel": "Anulować"
    },
    "empty": {
      "title": "Nie znaleziono żądań",
      "pending": "Brak oczekujących wniosków do rozpatrzenia.",
      "filtered": "Żaden wniosek urlopowy nie spełnia kryteriów filtra."
    },
    "modal": {
      "reject_title": "Odrzuć żądanie",
      "reason_label": "Powód odrzucenia",
      "reason_placeholder": "Powód wniosku urlopowego...",
      "reject_button": "Odrzucić",
      "request_title": "Wniosek o urlop",
      "employee_label": "Pracownik",
      "leave_type_label": "Rodzaj urlopu",
      "start_date_label": "Data rozpoczęcia",
      "end_date_label": "Data zakończenia",
      "start_time_label": "Czas rozpoczęcia",
      "end_time_label": "Czas końcowy",
      "reason_optional": "Powód (opcjonalnie)",
      "submit_button": "Wyślij żądanie",
      "submitting": "Przedkładający...",
      "minimum_duration": "Minimum: {duration} {unit}"
    }
  },
  "calendar": {
    "page_title": "Kalendarz zespołu",
    "page_subtitle": "Wyświetlanie nieobecności zespołu i zaplanowanych urlopów",
    "filters": {
      "button": "Filtry"
    },
    "sync": {
      "title": "Synchronizuj swój kalendarz",
      "description": "Podłącz swój kalendarz osobisty, aby automatycznie synchronizować zatwierdzone urlopy"
    },
    "connect": {
      "google": "Kalendarz Google",
      "microsoft": "Kalendarz Microsoft"
    },
    "action": {
      "disconnect": "Odłączyć",
      "sync_my_leave": "Synchronizuj mój urlop",
      "sync_team_leave": "Synchronizuj zespół Leave"
    },
    "connecting": "Złączony...",
    "syncing": "Synchronizacja...",
    "autosync": {
      "title": "Automatyczna synchronizacja urlopu zespołu",
      "description": "Automatycznie dodawaj zatwierdzone urlopy członków zespołu do kalendarza"
    },
    "filter": {
      "department_label": "Dział",
      "all_departments": "Wszystkie działy",
      "location_label": "Lokalizacja",
      "all_locations": "Wszystkie lokalizacje",
      "leave_type_label": "Rodzaj urlopu",
      "all_types": "Wszystkie typy",
      "status_label": "Status",
      "all_status": "Wszystkie statusy"
    },
    "nav": {
      "today": "Dzisiaj"
    },
    "view": {
      "day": "Dzień",
      "week": "Tydzień",
      "month": "Miesiąc"
    },
    "legend": {
      "pending": "Aż do",
      "holiday": "Wakacje"
    },
    "day_view": {
      "empty": "W tym dniu nie ma liści"
    },
    "more": "+{count} więcej"
  },
  "team": {
    "page_title": "Zespół",
    "page_subtitle": "Zarządzaj członkami zespołu",
    "tab": {
      "active": "Aktywni",
      "inactive": "Nieaktywni",
      "deleted": "Usunięci"
    },
    "add_user": "Dodaj użytkownika",
    "import_from_slack": "Importuj ze Slacka",
    "bulk_import": "Import zbiorczy",
    "invite_member": "Zaproś członka",
    "search_placeholder": "Szukaj członków zespołu...",
    "table": {
      "name": "Imię i nazwisko",
      "email": "E-mail",
      "department": "Dział",
      "location": "Lokalizacja",
      "role": "Rola",
      "status": "Status",
      "manager": "Przełożony",
      "start_date": "Data rozpoczęcia",
      "birthday": "Urodziny",
      "working_days": "Dni robocze",
      "hours_per_week": "Godziny tygodniowo",
      "employment_type": "Typ zatrudnienia",
      "actions": "Akcje"
    },
    "filter": {
      "all_departments": "Wszystkie działy",
      "all_locations": "Wszystkie lokalizacje",
      "all_roles": "Wszystkie role",
      "all_statuses": "Wszystkie statusy"
    },
    "role": {
      "owner": "Właściciel",
      "admin": "Administrator",
      "approver": "Zatwierdzający",
      "employee": "Pracownik"
    },
    "card": {
      "department": "Dział",
      "location": "Lokalizacja",
      "manager": "Przełożony",
      "start_date": "Data rozpoczęcia",
      "birthday": "Urodziny",
      "working_days": "Dni robocze",
      "balance": "Saldo",
      "no_manager": "Brak przełożonego",
      "no_department": "Brak działu",
      "no_location": "Brak lokalizacji"
    },
    "action": {
      "edit": "Edytuj",
      "view": "Zobacz",
      "deactivate": "Dezaktywuj",
      "activate": "Aktywuj",
      "delete": "Usuń",
      "restore": "Przywróć",
      "permanent_delete": "Trwale usuń",
      "adjust_balance": "Dostosuj saldo",
      "view_history": "Zobacz historię",
      "send_invite": "Wyślij zaproszenie",
      "resend_invite": "Wyślij ponownie zaproszenie"
    },
    "empty": {
      "title": "Nie znaleziono członków zespołu",
      "active": "Brak aktywnych członków zespołu.",
      "inactive": "Brak nieaktywnych członków zespołu.",
      "deleted": "Brak usuniętych członków zespołu.",
      "search": "Nie znaleziono członków zespołu dla \"{query}\".",
      "filtered": "Brak członków zespołu spełniających kryteria filtrowania."
    },
    "modal": {
      "edit_title": "Edytuj członka zespołu",
      "add_title": "Dodaj członka zespołu",
      "invite_title": "Zaproś członka zespołu",
      "view_title": "Szczegóły członka zespołu",
      "name_label": "Imię i nazwisko",
      "email_label": "E-mail",
      "department_label": "Dział",
      "location_label": "Lokalizacja",
      "role_label": "Rola",
      "manager_label": "Przełożony",
      "start_date_label": "Data rozpoczęcia",
      "birthday_label": "Urodziny",
      "working_days_label": "Dni robocze",
      "hours_per_week_label": "Godziny tygodniowo",
      "employment_type_label": "Typ zatrudnienia",
      "select_department": "Wybierz dział",
      "select_location": "Wybierz lokalizację",
      "select_manager": "Wybierz przełożonego",
      "select_role": "Wybierz rolę",
      "no_manager": "Brak przełożonego"
    },
    "toil": {
      "title": "Odbiór godzin (TOIL)",
      "add_button": "Dodaj TOIL",
      "hours_label": "Godziny",
      "reason_label": "Powód",
      "date_label": "Data",
      "balance": "Saldo TOIL",
      "no_entries": "Brak wpisów TOIL"
    },
    "invite": {
      "title": "Zaproś członka zespołu",
      "email_label": "Adres e-mail",
      "email_placeholder": "jan.kowalski@firma.pl",
      "role_label": "Rola",
      "department_label": "Dział",
      "location_label": "Lokalizacja",
      "message_label": "Wiadomość (opcjonalnie)",
      "message_placeholder": "Dodaj osobistą wiadomość do zaproszenia...",
      "send_button": "Wyślij zaproszenie",
      "success": "Zaproszenie zostało wysłane",
      "error": "Nie udało się wysłać zaproszenia"
    },
    "bulk": {
      "title": "Import zbiorczy",
      "description": "Zaimportuj wielu członków zespołu za pomocą pliku CSV",
      "download_template": "Pobierz szablon CSV",
      "upload_file": "Prześlij plik CSV",
      "select_file": "Wybierz plik",
      "file_selected": "Wybrany plik: {filename}",
      "preview": "Podgląd",
      "import_button": "Importuj",
      "importing": "Importowanie...",
      "success": "Pomyślnie zaimportowano {count} członków zespołu",
      "partial_success": "Zaimportowano {success} z {total} członków zespołu",
      "error": "Nie udało się zaimportować członków zespołu",
      "validation_errors": "Znaleziono błędy walidacji",
      "row": "Wiersz",
      "errors": "Błędy"
    },
    "instances": {
      "title": "Wykorzystanie urlopu",
      "lifetime_used": "Wykorzystano (łącznie)",
      "lifetime_limit": "Limit całkowity",
      "remaining": "Pozostało",
      "no_limit": "Bez limitu",
      "history": "Historia wykorzystania"
    },
    "confirm": {
      "deactivate": "Czy na pewno chcesz dezaktywować tego użytkownika?",
      "deactivate_warning": "Użytkownik straci dostęp do aplikacji, ale jego dane zostaną zachowane.",
      "delete": "Czy na pewno chcesz usunąć tego użytkownika?",
      "delete_warning": "Użytkownik zostanie przeniesiony do zakładki Usunięci.",
      "permanent_delete": "Czy na pewno chcesz TRWALE USUNĄĆ użytkownika {name}?",
      "permanent_delete_warning": "Tej czynności nie można cofnąć. Cała historia urlopów i salda zostaną usunięte.",
      "permanent_delete_final": "To jest trwałe! Kliknij OK, aby potwierdzić trwałe usunięcie.",
      "restore": "Czy na pewno chcesz przywrócić tego użytkownika?",
      "restore_info": "Użytkownik zostanie przywrócony jako nieaktywny."
    },
    "error": {
      "load": "Nie udało się załadować członków zespołu",
      "deactivate": "Nie udało się dezaktywować użytkownika",
      "activate": "Nie udało się aktywować użytkownika",
      "delete": "Nie udało się usunąć użytkownika",
      "restore": "Nie udało się przywrócić użytkownika",
      "permanent_delete": "Nie udało się trwale usunąć użytkownika",
      "update": "Nie udało się zaktualizować użytkownika",
      "invite": "Nie udało się wysłać zaproszenia",
      "import": "Nie udało się zaimportować użytkowników"
    }
  },
  "settings": {
    "page_title": "Ustawienia",
    "page_subtitle": "Skonfiguruj ustawienia i zasady swojego obszaru roboczego",
    "access_denied": {
      "title": "Wymagany dostęp administratora",
      "message": "Aby uzyskać dostęp do ustawień, musisz mieć uprawnienia administratora."
    },
    "tab": {
      "workspace": "Przestrzeń robocza",
      "departments": "Działy",
      "locations": "Lokalizacje",
      "holidays": "Ferie",
      "compliance": "Zgodność",
      "balances": "Saldo początkowe",
      "notifications": "Powiadomienia",
      "integrations": "Integracje",
      "import": "Import",
      "data_management": "Zarządzanie danymi",
      "locked_tooltip": "Zaktualizuj, aby odblokować tę funkcję"
    },
    "workspace": {
      "title": "Ustawienia obszaru roboczego",
      "name_label": "Nazwa obszaru roboczego",
      "visibility_label": "Pozostaw widoczność",
      "visibility": {
        "all": "Wszyscy mogą zobaczyć, jak wszyscy wychodzą",
        "department": "Zobacz tylko własny dział",
        "approvers": "Tylko osoby zatwierdzające mogą zobaczyć wszystko"
      },
      "save_button": "Zapisz zmiany"
    },
    "departments": {
      "title": "Działy",
      "subtitle": "Zorganizuj swój zespół w działach, stosując niestandardowe zasady",
      "add_button": "Dodaj dział",
      "name_label": "Nazwa wydziału",
      "working_days_label": "Dni robocze",
      "hours_per_day_label": "Godzin dziennie",
      "approvers_label": "Zatwierdzający",
      "notification_channel_label": "Kanał powiadomień",
      "policies_button": "Zarządzaj zasadami",
      "edit_button": "Redagować",
      "delete_button": "Usuwać",
      "confirm_delete": "Czy na pewno chcesz usunąć ten dział?",
      "no_departments": "Nie utworzono jeszcze żadnych działów"
    },
    "locations": {
      "title": "Lokalizacje",
      "subtitle": "Zarządzaj lokalizacjami biur i kalendarzami świąt",
      "add_button": "Dodaj lokalizację",
      "name_label": "Nazwa lokalizacji",
      "country_label": "Kraj",
      "timezone_label": "Strefa czasowa",
      "edit_button": "Redagować",
      "delete_button": "Usuwać",
      "no_locations": "Nie utworzono jeszcze żadnych lokalizacji"
    },
    "holidays": {
      "title": "Święta państwowe",
      "subtitle": "Zarządzaj świętami państwowymi dla każdej lokalizacji",
      "add_button": "Dodaj święto",
      "location_label": "Lokalizacja",
      "all_locations": "Wszystkie lokalizacje",
      "year_label": "Rok",
      "name_label": "Nazwa święta",
      "date_label": "Data",
      "half_day_label": "Pół dnia",
      "edit_button": "Redagować",
      "delete_button": "Usuwać",
      "no_holidays": "Brak świąt w tej lokalizacji i roku",
      "import_button": "Święta importowe"
    },
    "leave_types": {
      "title": "Rodzaje urlopów",
      "subtitle": "Konfiguruj rodzaje i uprawnienia urlopowe",
      "add_button": "Dodaj typ urlopu",
      "name_label": "Nazwa",
      "color_label": "Kolor",
      "unit_label": "Jednostka",
      "unit": {
        "days": "Dni",
        "hours": "Godziny"
      },
      "entitlement_label": "Domyślne uprawnienie",
      "unlimited": "Nieograniczony",
      "requires_approval_label": "Wymaga zatwierdzenia",
      "allow_half_day_label": "Pozwól na pół dnia",
      "is_paid_label": "Urlop płatny",
      "carryover_label": "Maksymalne przeniesienie",
      "priority_label": "Priorytet",
      "edit_button": "Redagować",
      "delete_button": "Usuwać",
      "no_leave_types": "Brak skonfigurowanych typów urlopu"
    },
    "notifications": {
      "title": "Powiadomienia",
      "subtitle": "Skonfiguruj sposób i czas wysyłania powiadomień",
      "slack_channel_label": "Kanał Slack",
      "email_notifications_label": "Powiadomienia e-mail",
      "daily_digest_label": "Codzienny przegląd",
      "weekly_summary_label": "Podsumowanie tygodniowe",
      "save_button": "Zapisz ustawienia"
    },
    "integrations": {
      "title": "Integracje",
      "subtitle": "Połącz swoje narzędzia HR i kalendarze",
      "connect_button": "Łączyć",
      "disconnect_button": "Odłączyć",
      "sync_button": "Synchronizuj teraz",
      "view_logs_button": "Wyświetl dzienniki",
      "last_sync": "Ostatnia synchronizacja: {data}",
      "never_synced": "Nigdy nie zsynchronizowane",
      "status": {
        "connected": "Połączony",
        "disconnected": "Nie połączony",
        "error": "Błąd"
      }
    },
    "data": {
      "title": "Zarządzanie danymi",
      "subtitle": "Utwórz kopię zapasową danych lub wyczyść informacje w obszarze roboczym",
      "current_data": "Aktualne dane",
      "total_users": "Łączna liczba użytkowników",
      "admins": "Administratorzy",
      "regular_users": "Zwykli użytkownicy",
      "leave_requests": "Prośby o urlop",
      "backup": {
        "title": "Pobierz kopię zapasową",
        "description": "Pobierz kompletną kopię zapasową danych swojego obszaru roboczego w postaci pliku JSON.",
        "button": "Pobierz kopię zapasową"
      },
      "google_drive": {
        "title": "Kopia zapasowa Dysku Google",
        "description": "Automatyczne codzienne kopie zapasowe na Dysku Google.",
        "connect_button": "Połącz Google Drive",
        "folder_label": "Folder kopii zapasowej",
        "auto_backup_label": "Włącz automatyczne codzienne tworzenie kopii zapasowych",
        "backup_now_button": "Utwórz kopię zapasową teraz",
        "last_backup": "Ostatnia kopia zapasowa: {data}",
        "upgrade_message": "W planie Business dostępne są codzienne automatyczne kopie zapasowe na Dysku Google."
      },
      "clear_users": {
        "title": "Wyczyść użytkowników bez uprawnień administratora",
        "description": "Usuń wszystkich użytkowników oprócz administratorów i właścicieli. Spowoduje to usunięcie {count} użytkowników, ich sald urlopowych i wszelkich oczekujących wniosków urlopowych.",
        "warning": "Ostrzeżenie: Tej czynności nie można cofnąć. Najpierw pobierz kopię zapasową.",
        "confirm_prompt": "Wpisz DELETE, aby potwierdzić",
        "confirm_description": "Spowoduje to trwałe usunięcie {count} użytkowników i wszystkich ich danych.",
        "button": "Wyczyść użytkowników bez uprawnień administratora",
        "confirm_button": "Potwierdź usunięcie użytkowników"
      },
      "clear_history": {
        "title": "Wyczyść historię urlopów",
        "description": "Usuń wszystkie wnioski urlopowe i zresetuj saldo wszystkich urlopów do zera. Spowoduje to usunięcie {count} wniosków urlopowych.",
        "warning": "Ostrzeżenie: Tej czynności nie można cofnąć. Cała historia urlopów zostanie trwale usunięta, a saldo zostanie zresetowane.",
        "confirm_description": "Spowoduje to trwałe usunięcie {count} wniosków urlopowych i zresetowanie wszystkich sald.",
        "button": "Wyczyść historię urlopów",
        "confirm_button": "Potwierdź wyczyść historię"
      },
      "restore": {
        "title": "Przywróć z kopii zapasowej",
        "description": "Prześlij plik JSON z kopią zapasową, aby przywrócić dane z obszaru roboczego. Spowoduje to zastąpienie wszystkich istniejących danych.",
        "warning": "Ostrzeżenie: Przywrócenie spowoduje zastąpienie wszystkich bieżących użytkowników, typów urlopów, wniosków urlopowych, działów i sald. Tylko właściciel obszaru roboczego może wykonać tę czynność.",
        "select_file": "Wybierz plik kopii zapasowej",
        "backup_details": "Szczegóły kopii zapasowej",
        "file": "Plik",
        "version": "Wersja",
        "created": "Stworzony",
        "confirm_prompt": "Wpisz RESTORE, aby potwierdzić",
        "confirm_description": "Spowoduje to, że wszystkie istniejące dane zostaną trwale zastąpione kopią zapasową.",
        "button": "Potwierdź przywrócenie",
        "restoring": "Przywracanie...",
        "success": "Przywracanie ukończone pomyślnie!"
      }
    }
  },
  "audit": {
    "page_title": "Ślad audytu",
    "page_subtitle": "Wyświetl wszystkie zmiany wprowadzone w Twojej przestrzeni roboczej",
    "super_admin_label": "(Superadministrator)",
    "entries_count": "całkowita liczba wpisów",
    "filter": {
      "action_label": "Typ akcji",
      "all_actions": "Wszystkie akcje",
      "entity_label": "Typ jednostki",
      "all_entities": "Wszystkie podmioty",
      "user_label": "Zmienione przez",
      "all_users": "Wszyscy użytkownicy"
    },
    "action": {
      "user_updated": "Zaktualizowano użytkownika",
      "user_deleted": "Użytkownik usunięty",
      "user_imported": "Użytkownik zaimportował",
      "leave_requested": "Żądany urlop",
      "leave_approved": "Urlop zatwierdzony",
      "leave_rejected": "Zostaw odrzucony",
      "leave_cancelled": "Urlop anulowany",
      "leave_type_created": "Utworzono typ urlopu",
      "leave_type_updated": "Zaktualizowano typ urlopu",
      "leave_type_deleted": "Typ urlopu usunięty",
      "balance_adjusted": "Saldo skorygowane",
      "department_created": "Utworzono dział",
      "department_updated": "Zaktualizowano dział",
      "department_deleted": "Dział usunięty",
      "audit_log_deleted": "Usunięto dziennik audytu"
    },
    "table": {
      "date": "Data",
      "user": "Użytkownik",
      "action": "Działanie",
      "entity": "Podmiot",
      "details": "Bliższe dane"
    },
    "no_entries": "Nie znaleziono wpisów w dzienniku audytu"
  },
  "billing": {
    "page_title": "Rozliczenia i subskrypcje",
    "page_subtitle": "Zarządzaj swoją subskrypcją i szczegółami rozliczeń",
    "access_denied": {
      "title": "Odmowa dostępu",
      "message": "Tylko właściciel obszaru roboczego może przeglądać i zarządzać rozliczeniami.",
      "button": "Powrót do pulpitu nawigacyjnego"
    },
    "current_plan": {
      "title": "Aktualny plan"
    },
    "status": {
      "none": "Brak subskrypcji"
    },
    "discount_badge": "Zastosowano {percent}% zniżki",
    "trial_info": {
      "title": "Okres próbny kończy się {data}",
      "days_remaining": "Pozostało {dni} dni"
    },
    "renewal_info": {
      "title": "Następna data rozliczenia"
    },
    "action": {
      "upgrade": "Uaktualnij do wersji Pro",
      "view_plans": "Zobacz wszystkie plany",
      "manage": "Zarządzaj subskrypcją"
    },
    "plan": {
      "trial": "Bezpłatny okres próbny",
      "free": "Bezpłatny",
      "pro": "Zawodowiec",
      "business": "Biznes"
    },
    "feature": {
      "up_to_5_users": "Do 5 użytkowników",
      "up_to_50_users": "Do 50 użytkowników",
      "unlimited_users": "Nieograniczona liczba użytkowników",
      "basic": "Podstawowe funkcje",
      "trial_14days": "14-dniowy okres próbny",
      "unlimited_requests": "Nieograniczone wnioski urlopowe",
      "slack_integration": "Integracja ze Slackiem",
      "planner": "Widok planera",
      "custom_leave_types": "Niestandardowe rodzaje urlopów",
      "approval_workflows": "Przepływy pracy zatwierdzania",
      "priority_support": "Wsparcie priorytetowe",
      "multi_team": "Wsparcie wielozespołowe",
      "analytics": "Zaawansowana analityka",
      "api_access": "Dostęp do API",
      "dedicated_support": "Dedykowane wsparcie"
    }
  },
  "upgrade": {
    "page_title": "Wybierz swój plan",
    "page_subtitle": "Prosty i przejrzysty cennik. Brak opłat za użytkownika.",
    "plan_badge": "Najpopularniejsze",
    "period": {
      "month": "/miesiąc",
      "year": "/rok"
    },
    "yearly_savings": "lub EUR {rocznie}/rok (oszczędzasz {procent}%)",
    "loading": "Ładowanie planów...",
    "guarantee": {
      "title": "30-dniowa gwarancja zwrotu pieniędzy",
      "description": "Niezadowolony? Uzyskaj pełny zwrot pieniędzy, bez zadawania pytań."
    },
    "faq": {
      "title": "Często zadawane pytania",
      "q1": "Czy mogę później zmienić plan?",
      "a1": "Tak, możesz w dowolnym momencie zmienić taryfę na wyższą lub niższą. Zmiany wchodzą w życie natychmiast i są proporcjonalne.",
      "q2": "Jakie metody płatności akceptujecie?",
      "a2": "Akceptujemy wszystkie najważniejsze karty kredytowe (Visa, Mastercard, American Express) za pośrednictwem naszego bezpiecznego dostawcy płatności Stripe.",
      "q3": "Czy istnieje umowa lub zobowiązanie?",
      "a3": "Nie, wszystkie plany są miesięczne. Możesz zrezygnować w dowolnym momencie bez żadnych kar.",
      "q4": "Co się stanie, gdy osiągnę limit użytkowników?",
      "a4": "Zostaniesz poproszony o przejście na wyższy plan. Obecni użytkownicy nadal będą mieli dostęp."
    },
    "contact_note": "Masz pytania? Skontaktuj się z nami pod adresem",
    "current_plan_badge": "Aktualny plan",
    "button": {
      "upgrade": "Przejdź na {plan}",
      "start_trial": "Rozpocznij bezpłatny okres próbny"
    }
  },
  "login": {
    "processing_title": "Logowanie...",
    "processing_message": "Poczekaj, aż zweryfikujemy Twoje dane uwierzytelniające w Slacku.",
    "subtitle": "Łatwe zarządzanie wnioskami urlopowymi Twojego zespołu",
    "slack_button": "Dodaj do Slacka",
    "existing_user_text": "Już korzystasz z Unplug?",
    "existing_user_info": "Otwórz aplikację w Slacku i kliknij „Panel administratora”, aby się zalogować.",
    "terms_text": "Kontynuując",
    "error": {
      "workspace_not_found": "Nie znaleziono obszaru roboczego. Sprawdź adres URL.",
      "invalid_response": "Nieprawidłowa odpowiedź z serwera",
      "generic": "Logowanie nieudane",
      "please_retry": "Logowanie nieudane. Spróbuj ponownie."
    }
  },
  "help": {
    "page_title": "Centrum pomocy",
    "page_subtitle": "Znajdź odpowiedzi i dowiedz się, jak korzystać z Unplug",
    "action": {
      "restart_tour": "Uruchom ponownie wycieczkę"
    },
    "search": {
      "placeholder": "Przeszukaj artykuły pomocy, FAQ...",
      "results": "Znaleziono {articles} artykułów i {faqs} często zadawanych pytań pasujących do {query}"
    },
    "quick_link": {
      "getting_started": "Rozpoczęcie pracy",
      "faqs": "Często zadawane pytania",
      "contact_support": "Skontaktuj się z pomocą techniczną",
      "tour": "Wybierz się na wycieczkę"
    }
  },
  "profile": {
    "page_title": "Ustawienia profilu",
    "personal_info": "Informacje osobiste",
    "name_label": "Pełne imię i nazwisko",
    "email_label": "E-mail",
    "department_label": "Dział",
    "location_label": "Lokalizacja",
    "manager_label": "Menedżer",
    "start_date_label": "Data rozpoczęcia",
    "save_button": "Zapisz zmiany",
    "preferences": "Preferencje",
    "language_label": "Język",
    "timezone_label": "Strefa czasowa"
  },
  "planner": {
    "page_title": "Planer",
    "page_subtitle": "Wizualny kalendarz zespołu pokazujący wszystkie nieobecności",
    "feature_name": "Planer",
    "feature_description": "Wizualny kalendarz zespołu pokazujący wszystkie nieobecności na pierwszy rzut oka",
    "empty_state": "Nie znaleziono członków zespołu",
    "filter": {
      "pending_request": "Oczekujący wniosek",
      "filter_by": "Filtruj według",
      "department": "Dział",
      "all_departments": "Wszystkie działy",
      "location": "Lokalizacja",
      "all_locations": "Wszystkie lokalizacje"
    },
    "export": {
      "button": "Eksportuj",
      "title": "Eksportuj dane urlopowe",
      "format": "Format eksportu",
      "buddy_payroll": "Buddy Payroll",
      "generic_csv": "Ogólny CSV",
      "date_range": "Zakres dat",
      "departments": "Działy"
    },
    "legend": {
      "approved": "Zatwierdzony",
      "pending": "Oczekujący",
      "holiday": "Święto",
      "holidays": "Święta",
      "weekend": "Weekend",
      "non_working": "Dzień wolny od pracy",
      "partial_day": "Nieobecności krótsze niż jeden dzień"
    },
    "no_data": "Brak nieobecności do wyświetlenia"
  },
  "error": {
    "network": "Błąd sieci. Sprawdź połączenie.",
    "unauthorized": "Nie masz uprawnień do wykonania tej czynności.",
    "not_found": "Żądany zasób nie został znaleziony.",
    "server": "Błąd serwera. Spróbuj ponownie później.",
    "validation": "Sprawdź, czy w formularzu nie ma błędów.",
    "generic": "Coś poszło nie tak. Spróbuj ponownie.",
    "session_expired": "Twoja sesja wygasła. Zaloguj się ponownie."
  },
  "success": {
    "saved": "Zmiany zostały pomyślnie zapisane.",
    "deleted": "Pomyślnie usunięto.",
    "created": "Utworzono pomyślnie.",
    "updated": "Zaktualizowano pomyślnie.",
    "submitted": "Wysłano pomyślnie.",
    "sent": "Wysłano pomyślnie."
  },
  "weekday": {
    "monday": "Poniedziałek",
    "tuesday": "Wtorek",
    "wednesday": "Środa",
    "thursday": "Czwartek",
    "friday": "Piątek",
    "saturday": "Sobota",
    "sunday": "Niedziela",
    "mon": "Poniedziałek",
    "tue": "wtorek",
    "wed": "Poślubić",
    "thu": "Czw",
    "fri": "Pt",
    "sat": "Sobota",
    "sun": "Słoneczny"
  },
  "month": {
    "january": "Styczeń",
    "february": "Luty",
    "march": "marzec",
    "april": "Kwiecień",
    "may": "Móc",
    "june": "Czerwiec",
    "july": "Lipiec",
    "august": "Sierpień",
    "september": "Wrzesień",
    "october": "Październik",
    "november": "Listopad",
    "december": "Grudzień",
    "jan": "Jan",
    "feb": "Luty",
    "mar": "Zniszczyć",
    "apr": "kwiecień",
    "may_short": "Móc",
    "jun": "Czerwiec",
    "jul": "Lipiec",
    "aug": "Sierpień",
    "sep": "Wrzesień",
    "oct": "Październik",
    "nov": "Listopad",
    "dec": "Grudzień"
  },
  "language": {
    "en": "angielski",
    "es": "hiszpański",
    "fr": "francuski",
    "de": "niemiecki",
    "it": "włoski",
    "pt": "portugalski",
    "pl": "Polski",
    "nl": "Holenderski",
    "sv": "szwedzki",
    "no": "norweski"
  },
  "leave_type_name": {
    "Vacation": "Urlop",
    "Vacation Leave": "Urlop wypoczynkowy",
    "Annual Leave": "Urlop roczny",
    "Unpaid Vacation": "Urlop bezpłatny",
    "Unpaid Leave": "Urlop bezpłatny",
    "Sick Leave": "Zwolnienie chorobowe",
    "Sick Leave (Full Pay)": "Zwolnienie chorobowe (pełne wynagrodzenie)",
    "Maternity Leave": "Urlop macierzyński",
    "Paternity Leave": "Urlop ojcowski",
    "Parental Leave": "Urlop rodzicielski",
    "Bereavement Leave": "Urlop okolicznościowy",
    "Marriage Leave": "Urlop ślubny",
    "Jury Leave": "Urlop ławniczy",
    "Jury Duty": "Obowiązek ławniczy",
    "Work Travel": "Podróż służbowa",
    "Working Remotely": "Praca zdalna",
    "Remote Work": "Praca zdalna",
    "Work From Home": "Praca z domu",
    "Personal Day": "Dzień osobisty",
    "TOIL": "Odbiór godzin",
    "Time Off In Lieu": "Odbiór godzin",
    "Compassionate Leave": "Urlop z przyczyn osobistych",
    "Study Leave": "Urlop szkoleniowy",
    "Training": "Szkolenie",
    "Public Holiday": "Święto"
  }
}